import { FC, InputHTMLAttributes, ReactNode } from 'react';
import LLButton from '../LLButton/LLButton';
import Image from 'next/image';
import Conditional from '@next-app/components/Conditional';

export interface LLRadioAccordionProps {
  children: ReactNode;
  firstChild?: boolean;
  lastChild?: boolean;
  isEditable: boolean;
  isExpanded: boolean;
  showRadioButton?: boolean;
  onToggle?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  customClass?: string;
  automationId?: string;
  index?: number;
}

const LLRadioAccordion: FC<
  LLRadioAccordionProps & InputHTMLAttributes<HTMLInputElement>
> = ({
  children,
  name,
  id,
  firstChild,
  lastChild,
  checked,
  value,
  onChange,
  onToggle,
  isEditable = false,
  isExpanded = false,
  showRadioButton = true, // Default is true
  disabled = false,
  customClass = '',
  automationId,
}) => {
  let classList: string[] = [
    customClass,
    'p-ll-3 d-flex align-items-center modal-accordian',
  ];

  if (isExpanded) {
    classList.push('selected');
  }
  if (firstChild) {
    classList.push('rounded-top');
  }
  if (lastChild) {
    classList.push('rounded-bottom');
  }
  if (disabled) {
    classList.push('ll-disabled-gray pe-none');
  }
  if (!showRadioButton && !isExpanded) {
    classList.push('rounded');
  }
  if (showRadioButton && checked) {
    classList.push('selected');
  }

  return (
    <label
      htmlFor={id}
      className={Array.from(new Set(classList)).join(' ')}
      style={disabled ? { pointerEvents: 'none' } : {}}
      aria-disabled={disabled}
    >
      <Conditional if={showRadioButton}>
        <span className="form-check m-0">
          <input
            role="button"
            className="form-check-input"
            type="radio"
            name={name}
            id={id}
            checked={checked}
            onChange={onChange}
            value={value}
            automation-id={automationId}
          />
        </span>
      </Conditional>
      <span className="d-flex justify-content-between w-100 overflow-hidden align-items-center">
        <span className="form-check-label px-1 w-100">{children}</span>
      </span>
      <Conditional if={isEditable && checked === true}>
        <LLButton
          customClass={`arrow-btn ${isExpanded ? 'up' : 'down'}`}
          onClick={onToggle}
          id={id}
        >
          <Image
            src="/react/assets/icons/arrow-down-heavy.svg"
            alt="down-arrow"
            height="12"
            width="12"
            unoptimized={true}
            id={id}
          />
        </LLButton>
      </Conditional>
    </label>
  );
};

export default LLRadioAccordion;
